var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.941,
    height: 16.834,
    viewBox: "0 0 23.941 16.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    d: "M24.491,7.134A3.008,3.008,0,0,0,22.374,5c-1.867-.5-9.354-.5-9.354-.5s-7.487,0-9.354.5A3.008,3.008,0,0,0,1.55,7.134a31.558,31.558,0,0,0-.5,5.8,31.558,31.558,0,0,0,.5,5.8,2.963,2.963,0,0,0,2.117,2.1c1.867.5,9.354.5,9.354.5s7.487,0,9.354-.5a2.963,2.963,0,0,0,2.117-2.1,31.558,31.558,0,0,0,.5-5.8,31.558,31.558,0,0,0-.5-5.8Zm-13.919,9.36V9.374l6.257,3.56-6.257,3.56Z",
    transform: "translate(-1.05 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeYoutube);
export default __webpack_public_path__ + "static/media/Icon awesome-youtube.5d53c60ae2a600c896c7e48e03704909.svg";
export { ForwardRef as ReactComponent };